import React, { useState } from "react";
import { Shield, User, Download, Loader } from "lucide-react";
import toast from "react-hot-toast";
import api from "../api";

export default function UserPanel() {
  const [hwid, setHwid] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dlLoading, setDlLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!hwid.trim()) return toast.error("Masukkan HWID");
    setLoading(true);
    try {
      const res = await api.post("/api/user_panel", { hwid: hwid.trim() });
      if (res.data.status === "ok") {
        setData(res.data);
      } else {
        toast.error("HWID tidak ditemukan atau belum terdaftar");
        setData(null);
      }
    } catch (e) {
      toast.error("Gagal menghubungi server");
    }
    setLoading(false);
  };

  const handleDownload = async () => {
    setDlLoading(true);
    try {
      const res = await api.post("/api/generate_download", { hwid: data.hwid });
      const url = res.data.url;
      if (!url) throw new Error("URL tidak ada");
      // Buka URL langsung — browser trigger download otomatis
      window.location.href = url;
      toast.success("Download dimulai!");
    } catch (err) {
      const msg = err?.response?.data?.detail || err.message || "Gagal";
      toast.error("Download gagal: " + msg);
    }
    setDlLoading(false);
  };

  if (!data) {
    return (
      <div style={s.container}>
        <div style={s.card}>
          <div style={s.iconWrap}><Shield size={32} color="#6366f1" /></div>
          <h1 style={s.title}>PipoClient Panel</h1>
          <p style={s.sub}>Masukkan HWID untuk cek status akun</p>
          <form onSubmit={handleLogin} style={s.form}>
            <input
              type="text" placeholder="Masukkan HWID kamu"
              value={hwid} onChange={(e) => setHwid(e.target.value)}
              style={s.input} autoFocus
            />
            <button type="submit" disabled={loading} style={s.btn}>
              {loading ? "Memverifikasi..." : "Cek Status"}
            </button>
          </form>
          <div style={s.hint}>
            <p style={{ color: "#64748b", fontSize: 12, margin: "16px 0 0" }}>
              💡 Jalankan PipoClient.exe untuk melihat HWID perangkat kamu
            </p>
          </div>
        </div>
      </div>
    );
  }

  const isExpired = data.expire && data.expire !== "unlimited" && new Date(data.expire) < new Date();

  return (
    <div style={s.container}>
      <div style={s.panel}>
        <div style={s.panelHeader}>
          <div style={s.iconWrap2}><User size={24} color="#4ade80" /></div>
          <div>
            <h2 style={s.panelTitle}>Akun Aktif</h2>
            <p style={s.panelSub}>Detail akses PipoClient kamu</p>
          </div>
        </div>

        <div style={s.grid}>
          <div style={s.infoBox}>
            <span style={s.label}>HWID</span>
            <span style={s.val}>{data.hwid}</span>
          </div>
          <div style={s.infoBox}>
            <span style={s.label}>Telegram</span>
            <span style={s.val}>{data.telegram ? `@${data.telegram}` : "-"}</span>
          </div>
          <div style={s.infoBox}>
            <span style={s.label}>Expire</span>
            <span style={{ ...s.val, color: isExpired ? "#f87171" : "#4ade80" }}>
              {data.expire && data.expire !== "unlimited" ? data.expire.slice(0, 10) : "Unlimited"}
              {isExpired && " (EXPIRED)"}
            </span>
          </div>
          <div style={s.infoBox}>
            <span style={s.label}>Uses Left</span>
            <span style={s.val}>{data.uses_left === -1 ? "Unlimited" : data.uses_left}</span>
          </div>
          <div style={s.infoBox}>
            <span style={s.label}>Terdaftar</span>
            <span style={s.val}>{data.created ? data.created.slice(0, 10) : "-"}</span>
          </div>
          <div style={s.infoBox}>
            <span style={s.label}>Status</span>
            <span style={{ ...s.val, color: isExpired ? "#f87171" : "#4ade80", fontWeight: 700 }}>
              {isExpired ? "EXPIRED" : "AKTIF ✓"}
            </span>
          </div>
        </div>

        {/* Download section */}
        <div style={s.dlSection}>
          <h3 style={s.dlTitle}><Download size={16} /> Download Software</h3>
          <button onClick={handleDownload} disabled={dlLoading} style={s.dlBtn}>
            {dlLoading
              ? <><Loader size={16} style={{animation:"spin 1s linear infinite"}} /> Menyiapkan link...</>
              : <><Download size={16} /> Download PipoClient.zip</>
            }
          </button>
          <p style={{color:"#64748b",fontSize:11,margin:"8px 0 0",textAlign:"center"}}>
            Link 1x pakai · expired 5 menit
          </p>
        </div>

        {/* Back button */}
        <button onClick={() => { setData(null); setHwid(""); }} style={s.backBtn}>
          ← Kembali
        </button>
      </div>
    </div>
  );
}

const s = {
  container: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Segoe UI',sans-serif", padding: 20 },
  card: { background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 16, padding: "40px 48px", width: 400, backdropFilter: "blur(10px)", textAlign: "center" },
  iconWrap: { background: "rgba(99,102,241,0.15)", borderRadius: "50%", width: 64, height: 64, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", border: "1px solid rgba(99,102,241,0.3)" },
  title: { color: "#fff", fontSize: 22, fontWeight: 700, margin: "0 0 8px" },
  sub: { color: "#8b9cb5", fontSize: 14, margin: "0 0 24px" },
  form: { display: "flex", flexDirection: "column", gap: 12 },
  input: { width: "100%", padding: "12px 16px", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 8, color: "#fff", fontSize: 13, fontFamily: "monospace", outline: "none", boxSizing: "border-box" },
  btn: { padding: "12px 0", background: "linear-gradient(135deg,#6366f1,#8b5cf6)", border: "none", borderRadius: 8, color: "#fff", fontSize: 15, fontWeight: 600, cursor: "pointer" },
  hint: { textAlign: "center" },
  // Panel logged in
  panel: { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 16, padding: "32px", width: 500, maxWidth: "95vw" },
  panelHeader: { display: "flex", alignItems: "center", gap: 14, marginBottom: 24 },
  iconWrap2: { background: "rgba(74,222,128,0.15)", borderRadius: "50%", width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(74,222,128,0.3)" },
  panelTitle: { color: "#fff", fontSize: 18, fontWeight: 700, margin: 0 },
  panelSub: { color: "#64748b", fontSize: 13, margin: "2px 0 0" },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 },
  infoBox: { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 8, padding: "12px 14px" },
  label: { display: "block", color: "#64748b", fontSize: 11, marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.5 },
  val: { display: "block", color: "#e2e8f0", fontSize: 13, fontWeight: 500, wordBreak: "break-all" },
  dlSection: { background: "rgba(99,102,241,0.08)", border: "1px solid rgba(99,102,241,0.2)", borderRadius: 10, padding: "16px 20px", marginBottom: 16 },
  dlTitle: { color: "#a5b4fc", fontSize: 14, fontWeight: 600, margin: "0 0 12px", display: "flex", alignItems: "center", gap: 8 },
  dlBtn: { display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "11px 0", background: "linear-gradient(135deg,#6366f1,#8b5cf6)", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", textDecoration: "none", width: "100%" },
  backBtn: { background: "none", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 8, padding: "9px 18px", color: "#94a3b8", fontSize: 13, cursor: "pointer", width: "100%" },
};
